import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { db } from '../../firebase';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { Card } from '../UI/Card';
import { Button } from '../UI/Button';

export const Leaderboard = () => {
  const { user, profile } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('points');

  useEffect(() => {
    fetchLeaderboard();
  }, [filter]);

  const fetchLeaderboard = async () => {
    try {
      let q = query(
        collection(db, 'users'),
        orderBy(filter, 'desc'),
        limit(20)
      );
      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((doc, index) => ({
        rank: index + 1,
        ...doc.data()
      }));
      setUsers(data);
    } catch (err) {
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  const getRankEmoji = (rank) => {
    if (rank === 1) return '🥇';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
    return `#${rank}`;
  };

  return (
    <div className="leaderboard-page">
      <div className="leaderboard-header">
        <h2>🏆 Top Tutors</h2>
        <div className="filter-tabs">
          <button
            className={filter === 'points' ? 'active' : ''}
            onClick={() => setFilter('points')}
          >
            ⭐ Most Points
          </button>
          <button
            className={filter === 'rating' ? 'active' : ''}
            onClick={() => setFilter('rating')}
          >
             Highest Rated
          </button>
        </div>
      </div>
      {loading ? (
        <p>Loading leaderboard...</p>
      ) : (
        <Card className="leaderboard-card">
          {users.map(user => (
            <div key={user.uid} className="leaderboard-item">
              <div className="rank">
                <span className="rank-emoji">{getRankEmoji(user.rank)}</span>
              </div>
              <div className="user-info">
                <div className="avatar">
                  {user.displayName?.charAt(0).toUpperCase() || 'U'}
                </div>
                <div className="details">
                  <span className="name">{user.displayName || 'User'}</span>
                  {user.isTeacher && <span className="teacher-badge">Teacher</span>}
                  <span className="grade">{user.grade || 'N/A'}</span>
                </div>
              </div>
              <div className="stats">
                {filter === 'points' ? (
                  <span className="stat-value">⭐ {user.points || 0} pts</span>
                ) : (
                  <span className="stat-value">🌟 {(user.rating || 0).toFixed(1)}</span>
                )}
              </div>
            </div>
          ))}
        </Card>
      )}
      <div className="leaderboard-info">
        <h3>How to Earn Points</h3>
        <ul>
          <li>✅ <strong>+1 point</strong> - When someone accepts your help offer</li>
          <li>❌ <strong>-1 point</strong> - Posting a tutoring request</li>
          <li>📈 <strong>Points double</strong> every 24h if your request is unclaimed</li>
        </ul>
      </div>
    </div>
  );
};
